<h2>Student</h2>
<app-vcl-filter [pageId]="pageId" [filterType]="'study'" [userInfos]="userInfos" [modes]="modes" [hasSearchKey]="true" [platformInfos]="platformInfos" (filterDataOutputEvent)="sendFilterData($event)">
</app-vcl-filter>
<app-student-manager [userInfos]="userInfos" [filterData]="filterData" [platformInfos]="platformInfos" (inProgress)="setProgress($event)"></app-student-manager>

